import { useLingui } from "@lingui/react/macro";
import { Button } from "@offstreetparking/design-system/forms";
import { Text } from "@offstreetparking/design-system/typography";
import { FlowModal as Modal } from "../../overlays/FlowModal/FlowModal";
type VoidPermitProps = {
	onDelete: () => void;
	isModalOpen: boolean;
	setIsModalOpen: (value: boolean) => void;
};
export const VoidPermitModal = ({ onDelete, isModalOpen, setIsModalOpen }: VoidPermitProps) => {
	const { t } = useLingui();
	return (
		<Modal
			i18n={{
				closeButton: t`Close`,
				cancelButton: t`Cancel`,
			}}
			isOpen={isModalOpen}
			onClose={() => setIsModalOpen(false)}
			actions={
				<>
					<Button
						intent="primary"
						type="button"
						data-testid="delete-permit-button"
						isDestructive
						onClick={() => {
							onDelete();
							setIsModalOpen(false);
						}}
					>
						{t`Cancel Permit`}
					</Button>
					<Button intent="tertiary" type="button" onClick={() => setIsModalOpen(false)}>
						{t`Cancel`}
					</Button>
				</>
			}
		>
			<div className="flex flex-col gap-4">
				<Text>{t`Are you sure you want to delete this permit?`}</Text>
			</div>
		</Modal>
	);
};
